module.exports = __webpack_public_path__ + "static/media/3-3-3@2x.60cd5132.png";